import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const NoteTextOutlineIcon = forwardRef<SVGSVGElement, IconProps>(function NoteTextOutlineIcon(
  { color = '', height = 18, width = 18, hasCursorPointer, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.26271 0C4.52013 0 4.72881 0.206638 4.72881 0.461538V0.830769H8.27119V0.461538C8.27119 0.206638 8.47987 0 8.73729 0C8.99471 0 9.20339 0.206638 9.20339 0.461538V0.851413C10.0513 0.929123 10.7295 1.22609 11.2113 1.73979C11.7725 2.33824 12 3.16002 12 4.06154V8.76923C12 9.67075 11.7725 10.4925 11.2113 11.091C10.6443 11.6956 9.80494 12 8.73729 12H4.26271C3.19506 12 2.35575 11.6956 1.78874 11.091C1.22754 10.4925 1 9.67075 1 8.76923V4.06154C1 3.16002 1.22754 2.33824 1.78874 1.73979C2.27046 1.22609 2.94874 0.929123 3.79661 0.851413V0.461538C3.79661 0.206638 4.00529 0 4.26271 0ZM3.79661 1.77923C3.17091 1.85136 2.74969 2.07162 2.47185 2.3679C2.12415 2.73868 1.9322 3.30152 1.9322 4.06154V8.76923C1.9322 9.52925 2.12415 10.0921 2.47185 10.4629C2.81375 10.8275 3.37274 11.0769 4.26271 11.0769H8.73729C9.62726 11.0769 10.1863 10.8275 10.5281 10.4629C10.8758 10.0921 11.0678 9.52925 11.0678 8.76923V4.06154C11.0678 3.30152 10.8758 2.73868 10.5281 2.3679C10.2503 2.07162 9.82909 1.85136 9.20339 1.77923V2.12308C9.20339 2.37798 8.99471 2.58462 8.73729 2.58462C8.47987 2.58462 8.27119 2.37798 8.27119 2.12308V1.75385H4.72881V2.12308C4.72881 2.37798 4.52013 2.58462 4.26271 2.58462C4.00529 2.58462 3.79661 2.37798 3.79661 2.12308V1.77923ZM3.79661 5.44615C3.79661 5.19125 4.00529 4.98462 4.26271 4.98462H8.73729C8.99471 4.98462 9.20339 5.19125 9.20339 5.44615C9.20339 5.70105 8.99471 5.90769 8.73729 5.90769H4.26271C4.00529 5.90769 3.79661 5.70105 3.79661 5.44615ZM3.79661 8.21538C3.79661 7.96048 4.00529 7.75385 4.26271 7.75385H6.5C6.75742 7.75385 6.9661 7.96048 6.9661 8.21538C6.9661 8.47029 6.75742 8.67692 6.5 8.67692H4.26271C4.00529 8.67692 3.79661 8.47029 3.79661 8.21538Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
